import { Component } from '@angular/core';
import {FormsModule} from '@angular/forms';
import {Router, RouterLink} from '@angular/router';
import {NgClass, NgStyle} from '@angular/common';
import {SharedModule} from '../../../../../shared/shared.module';
import {environment} from '../../../../../../environments/environment';

@Component({
  selector: 'app-register-step1',
  standalone: true,
    imports: [
        FormsModule,
        RouterLink,
        SharedModule,
        NgStyle,
        NgClass
    ],
  templateUrl: './register-step1.component.html',
  styleUrl: './register-step1.component.scss'
})
export class RegisterStep1Component {

    public show = false;
    typeUser = '';
    structure = environment.globals.structure;
    candidat = environment.globals.candidat;

    constructor(private router: Router) { }

    // tslint:disable-next-line:typedef
    ngOnInit() {
        this.structure = environment.globals.structure;
        this.candidat = environment.globals.candidat;
        this.typeUser = this.candidat;
    }

    // tslint:disable-next-line:typedef
    showPassword() {
        this.show = !this.show;
    }
    // tslint:disable-next-line:typedef
    checkTypeUser(type: string){
        this.typeUser = type;
    }


}
